const Constant = {
  SHOW: 'SHOW_MODAL',
  HIDE: 'HIDE_MODAL',
};

export default Constant;
